// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../iot-devtool/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../iot-devtool/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modalchange-password .ant-col-sm-5 {\n    max-width: 100% !important;\n}", "",{"version":3,"sources":["webpack://./src/apps/auth/pages/login.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B","sourcesContent":[".modalchange-password .ant-col-sm-5 {\n    max-width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
